import logoUrl from '@/assets/Logo_Only.png';
import { BlurText } from '@/components/react-bits/BlurText';
import { formatDateId } from '@/lib/format';
import { BRAND } from '../palette';

/**
 * Masthead for the public Siji Fixed Link page: logo, title, "Data per".
 *
 * “Data per” is live (`dataFreshness` from the selected fund). The subtitle is
 * editorial — it describes what the page contains, not a hard-coded date range.
 */
export function SflMasthead({ dataFreshness }: { dataFreshness: string | null | undefined }) {
  const asOf = dataFreshness ? formatDateId(dataFreshness.slice(0, 10)) : null;

  return (
    <div
      className="flex justify-between items-end flex-wrap gap-5 pb-6"
      style={{ borderBottom: `1px solid ${BRAND.panelBorder}` }}
    >
      <div className="flex items-center gap-4 min-w-0">
        <img
          src={logoUrl}
          alt="Asuransi Simas Jiwa"
          className="shrink-0"
          style={{ height: 40, width: 'auto' }}
        />
        <div className="min-w-0">
          <BlurText
            text="Siji Fixed Income Fund · Performance Review"
            as="p"
            className="uppercase mb-2.5"
            delay={40}
            style={{
              fontSize: 11,
              letterSpacing: '3px',
              color: BRAND.red,
              fontFamily: 'var(--font-sans)',
            }}
          />
          <h1
            style={{
              fontSize: 'clamp(24px, 4vw, 32px)',
              fontWeight: 400,
              letterSpacing: '-0.5px',
              lineHeight: 1.15,
              color: BRAND.black,
              fontFamily: 'var(--font-display)',
            }}
          >
            Siji Fixed Link —{' '}
            <em style={{ fontStyle: 'italic', color: BRAND.red }}>NAV Dashboard</em>
          </h1>
          <BlurText
            text="Pergerakan NAV, pertumbuhan bulanan, YOY, dan analisa kondisi pasar"
            as="p"
            className="mt-2"
            delay={50}
            style={{ fontSize: 13.5, color: BRAND.textDim, fontFamily: 'var(--font-sans)' }}
          />
        </div>
      </div>
      <div className="text-right shrink-0" style={{ fontSize: 12, color: BRAND.textDim }}>
        Data per
        <div
          className="mt-1 italic tabular-nums"
          style={{ fontSize: 18, color: BRAND.red, fontFamily: 'var(--font-display)' }}
        >
          {asOf ?? '—'}
        </div>
      </div>
    </div>
  );
}
